import Link from "next/link";
import { MapPin } from "lucide-react";

type HomepageAvailabilityNoticeProps = {
  city?: string | null;
  href: string;
  onBrowseLaunch: () => void;
};

export default function HomepageAvailabilityNotice({
  city,
  href,
  onBrowseLaunch,
}: HomepageAvailabilityNoticeProps) {
  const selectedCity = String(city || "").trim();
  const heading = selectedCity
    ? `YourBarrio isn’t in ${selectedCity} yet`
    : "YourBarrio isn’t in your area yet";

  return (
    <section
      className="relative z-20 w-full border-y border-[#e2dfe8] bg-[#f5f4f7] py-4 sm:py-5"
      data-testid="homepage-city-availability-notice"
      aria-labelledby="homepage-city-availability-heading"
    >
      <div className="mx-auto w-full max-w-6xl px-4 sm:px-6 md:px-8">
        <div className="flex flex-col gap-2.5 sm:flex-row sm:items-center sm:justify-between sm:gap-6">
          <div className="flex min-w-0 items-start gap-2.5">
            <MapPin
              className="mt-0.5 h-4 w-4 shrink-0 text-[#74588e]"
              aria-hidden="true"
            />
            <div className="min-w-0">
              <h2
                id="homepage-city-availability-heading"
                className="text-base font-semibold tracking-[-0.025em] text-slate-900 sm:text-[1.05rem]"
              >
                {heading}
              </h2>
              <p className="mt-0.5 text-sm leading-5 text-slate-600">
                We’re launching first in Long Beach and expanding to nearby cities.
              </p>
            </div>
          </div>

          <Link
            href={href}
            prefetch={false}
            onClick={onBrowseLaunch}
            className="inline-flex min-h-11 shrink-0 items-center gap-1.5 self-start text-sm font-semibold text-[#4d3065] transition-colors hover:text-[#3f2858] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#6f548b]/60 focus-visible:ring-offset-2 focus-visible:ring-offset-[#f5f4f7] sm:self-auto"
            aria-label="Browse Long Beach listings"
          >
            <span className="border-b border-[#4d3065]/30 pb-px transition-colors hover:border-[#3f2858]">
              Browse Long Beach listings
            </span>
            <span aria-hidden="true">→</span>
          </Link>
        </div>
      </div>
    </section>
  );
}
